import { Component } from '@angular/core';
import { NavbarComponent } from '../../components/navbar/navbar.component';

@Component({
   selector: 'about-page',
   standalone: true,
   imports: [NavbarComponent],
   templateUrl: './about-page.component.html',
   styleUrl: './about-page.component.scss',
})
export class AboutPageComponent {
   currentSection = 'about';
}
